import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  isSidebarOpen = true;
  isMobileView = false;
  showLayout = true;
  isSidebarVisible = true;

  /** Toggles body scroll for mobile sidebar states */
  updateBodyScroll(): void {
    document.body.style.overflow =
      this.isMobileView && this.isSidebarOpen ? 'hidden' : '';
  }

  /** Resets layout (used on logout or forced teardown) */
  resetLayout(): void {
    this.isSidebarOpen = false;
    this.showLayout = false;
    this.isSidebarVisible = true;
    this.updateBodyScroll();
  }

  /**
   * Soft reinitialization after route or community change.
   * Safely recalculates viewport + visibility.
   */
  reinitLayout(): void {
    const width = window.innerWidth;
    this.isMobileView = width < 768;
    this.isSidebarOpen = !this.isMobileView && this.showLayout;
    this.isSidebarVisible = true;
    this.updateBodyScroll();
    document.body.classList.toggle('layout-visible', this.showLayout);
    console.log('[LayoutService] Layout reinitialized');
  }

  /**
   * Optional helper to force show layout after login.
   */
 forceShowLayout(): void {
  this.showLayout = true;
  this.isSidebarVisible = true;
  this.isSidebarOpen = window.innerWidth >= 768;
  document.body.classList.add('layout-visible');
  this.updateBodyScroll();
  console.log('[LayoutService] forceShowLayout called');
}


}
